import { request } from "../index"
export function getIPI() {
    return request({ url: "ipi/" })
}
export function createIPI(data = {}) {
    return request({ url: "ipi/", method: "POST", data })
}
export function updateIPI(data = {}) {
    return request({ url: `ipi/${data.id}/`, method: "PUT", data })
}
export function createPIS(data = {}) {
    return request({ url: "pis/", method: "POST", data })
}
export function updatePIS(data = {}) {
    return request({ url: `pis/${data.id}/`, method: "PUT", data })
}
export function getPIS() {
    return request({ url: "pis/" })
}
export function getCOFINS() {
    return request({ url: "cofins/", })
}
export function createCOFINS(data = {}) {
    return request({ url: "cofins/", method: "POST", data })
}
export function updateCOFINS(data = {}) {
    return request({ url: `cofins/${data.id}/`, method: "PUT", data })
}


// WEBPACK FOOTER //
// ./src/api/products/taxes.js